const services = [
  {
    slug: "unterhaltsreinigung",
    title: "Unterhaltsreinigung",
    points: [
      "Tägliche oder wöchentliche Reinigung",
      "Saubere Büros und Arbeitsplätze",
      "Zuverlässiges & geschultes Personal",
      "Flexible Einsatzzeiten",
      "Umweltfreundliche Reinigungsmittel",
    ],
    img: "/images/unterhalt.jpg",
    detailImg: "/images/unterhalt-detail.jpg",
    detailText:
      "Unsere Unterhaltsreinigung sorgt für dauerhaft gepflegte und hygienische Räume – sei es in Büros, Praxen oder öffentlichen Einrichtungen in Berlin und im Berliner Umland. Wir entwickeln individuelle Reinigungskonzepte, die exakt auf Ihre Bedürfnisse, Frequenz und Räumlichkeiten abgestimmt sind. Durch den Einsatz geschulten Personals und umweltschonender Reinigungsmittel garantieren wir höchste Qualität, Zuverlässigkeit und Diskretion – damit Sie sich auf das Wesentliche konzentrieren können.",
  },
  {
    slug: "glas-fassadenreinigung",
    title: "Glas- & Fassadenreinigung",
    points: [
      "Streifenfreie Glasflächen innen & außen",
      "Fassadenreinigung mit Hubarbeitsbühne",
      "Entfernung von Witterungs- & Umwelteinflüssen",
      "Schutz & Werterhalt Ihrer Immobilie",
      "Erfahrung mit Glas, Metall, Stein & Kunststoff",
    ],
    img: "/images/glas.jpeg",
    detailImg: "/images/glas-detail.jpg",
    detailText:
      "Wir reinigen Glasflächen und Fassaden aller Art in Berlin und Umgebung – von Bürogebäuden über Schaufenster bis hin zu großen Glasfronten. Dabei setzen wir auf moderne, materialschonende Reinigungsmethoden, die für streifenfreie Sauberkeit und nachhaltigen Glanz sorgen. Unsere Teams arbeiten effizient, sicher und mit größter Sorgfalt, auch an schwer zugänglichen Stellen.",
  },
  {
    slug: "baureinigung",
    title: "Baureinigung",
    points: [
      "Kostenlose Vor-Ort-Begehung & Beratung",
      "Jahrelange Erfahrung mit Bauprojekten",
      "Termintreue & flexible Einsatzzeiten",
      "Entfernung von Bauschutt, Staub & Rückständen",
      "Fein- & Grobreinigung vor Übergabe",
    ],
    img: "/images/baureinigung.jpg",
    detailImg: "/images/baureinigung-detail.jpg",
    detailText:
      "Ob Bauendreinigung oder Zwischenreinigung in Berlin und im Umland – wir übernehmen die gründliche Reinigung Ihrer Baustelle. Von Bauschutt und Staub bis hin zu hartnäckigen Verschmutzungen entfernen wir Rückstände fachgerecht und termingerecht, damit Ihre Immobilie sauber und bezugsfertig übergeben werden kann.",
  },
  {
    slug: "grundreinigung",
    title: "Grundreinigung",
    points: [
      "Tiefenreinigung schwer zugänglicher Bereiche",
      "Effektive Entfernung hartnäckiger Verschmutzungen",
      "Einsatz professioneller Reinigungsmittel & Maschinen",
      "Full-Service für alle Boden- & Oberflächenarten",
      "Einhaltung aller gesetzlichen Hygienevorgaben",
    ],
    img: "/images/grundreinigung.jpg",
    detailImg: "/images/grundreinigung-detail.jpg",
    detailText:
      "Unsere Grundreinigung entfernt tiefsitzende Verschmutzungen von Böden, Ecken, Fugen und schwer zugänglichen Stellen in Berlin und Umgebung – gründlich und hygienisch. Ob in Büros, Treppenhäusern oder Sanitärbereichen: Sie eignet sich als Ergänzung zur Unterhaltsreinigung oder bei einem besonderen Anlass.",
  },
  {
    slug: "teppichreinigung",
    title: "Teppichreinigung",
    points: [
      "Tiefenreinigung bis in die Fasern",
      "Materialschonende Behandlung aller Teppicharten",
      "Effektive Geruchs- und Fleckenentfernung",
      "Schnelle Trocknung durch moderne Verfahren",
      "Hygienisch sauber – ideal für Allergiker",
    ],
    img: "/images/teppichreinigung.jpg",
    detailImg: "/images/teppichreinigung-detail.jpg",
    detailText:
      "Unsere Teppichreinigung in Berlin und Umgebung beseitigt tiefsitzenden Schmutz, Flecken und Gerüche – schonend und gründlich. Wir achten auf die Materialverträglichkeit, damit Farben und Fasern erhalten bleiben. Das Verfahren eignet sich für Haushalte mit Kindern, Haustieren oder Allergikern.",
  },
];

export default services;
